import events from 'events.js';

function listener(evt, eventName, trackPhoneHS) {
    const elem = evt.currentTarget;
    const trackEvent = elem.getAttribute('data-event');
    const type = elem.getAttribute('data-id');
    const locationId = elem.getAttribute('data-location');
    const phone = elem.getAttribute('data-phone');
    // on first click show phone number, but prevent call
    // then remove this function
    if (trackPhoneHS) {
        if (trackEvent) {
            trackPhoneHS(trackEvent, phone, locationId, elem);
        } else {
            trackPhoneHS(phone, type, elem);
        }
    }
    const showFull = elem.getElementsByClassName('show-full').length;
    elem.innerText = phone;
    elem.removeAttribute('title');
    if (showFull) {
        evt.preventDefault();
    }
    // stop this firing a second time
    events.unlisten(elem, 'click', listener);
    // AdWords conversion
    if (typeof window.goog_report_conversion !== 'undefined') {
        window.goog_report_conversion();
    }
}

export default async function trackPhones(trackPhoneHS, eventName = 'phone') {
    await events.ready();

    for (const elem of document.querySelectorAll('a[data-phone]')) {
        events.listen(elem, 'click', (evt) =>
            listener(evt, eventName, trackPhoneHS),
        );
    }
}
